import React from 'react';

import LoadExperiences from 'bundle-loader?lazy&name=home!./components/routes/experiences/Experiences.jsx';
import LoadExperience from 'bundle-loader?lazy&name=home!./components/routes/experience/Experience.jsx';


const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [
    {
        title: 'Experiences',
        pattern: '/',
        load: LoadExperiences,
        key: 'experiences'
    },
    {
        title: 'Experience',
        pattern: '/experience',
        load: LoadExperience,
        key: 'experience'
    },
    {
        title: 'Experience',
        pattern: '/experience/:experienceId',
        load: LoadExperience,
        key: 'experienceEdit'
    }
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;
    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}